import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/geofences/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/geofences',
      params: { workspaceId: params.workspaceId },
      replace: true,
    });
  },
});
